import PropTypes from "prop-types";
import React, { PureComponent } from "react";
import { Button, Modal, Row } from "react-bootstrap";
import { StyleSheet, css } from "aphrodite";

const strings = {
    previewMedia: "Preview Media",
    close: "Close",
};

const styles = StyleSheet.create({
    imagePreview: {
        objectFit: "contain",
        maxWidth: "100%",
        maxHeight: "100%",
    },
    videoPreview: {
        width: "100%",
        maxHeight: "100%",
        objectFit: "contain",
    },
});

export default class PreviewMediaModal extends PureComponent {
    static propTypes = {
        show: PropTypes.bool.isRequired,
        handleClose: PropTypes.func.isRequired,
        mediaType: PropTypes.oneOf(["image", "video"]).isRequired,
        url: PropTypes.string.isRequired,
    };

    render() {
        return (
            <Modal show={this.props.show} onHide={this.props.handleClose}>
                <Modal.Header closeButton>
                    <Modal.Title>{strings.previewMedia}</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    {this.props.mediaType === "image" && (
                        <img
                            src={this.props.url}
                            alt="preview"
                            className={css(styles.imagePreview)}
                        />
                    )}
                    {this.props.mediaType === "video" && (
                        <video
                            className={css(styles.videoPreview)}
                            src={this.props.url}
                            type="video/mp4"
                            controls
                            preload="none"
                        />
                    )}
                    <Row>
                        <Button bsStyle="link" onClick={this.props.handleClose}>
                            {strings.close}
                        </Button>
                    </Row>
                </Modal.Body>
            </Modal>
        );
    }
}
